import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Field, HandleBitSet } from '../../../domain/dynamic-form-model';

@Component({
  selector: 'app-field',
  templateUrl: './dynamic-form-fields.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DynamicFormFieldsComponent {
  @Input() fieldData: Field;
  @Input() form: UntypedFormGroup;
  @Input() editMode: boolean;
  @Input() readonly: boolean = null;
  @Input() scrollContainer: HTMLElement | null = null;

  @Output() hasChanges = new EventEmitter<boolean>();
  @Output() handleBitSets = new EventEmitter<Field>();
  @Output() handleBitSetsOfComposite = new EventEmitter<HandleBitSet>();

  /** Bitsets--> **/

  updateBitSet(fieldData: Field) {
    this.timeOut(200).then(() => { // Needed for radio buttons strange behaviour
      if (fieldData.form.mandatory) {
        this.handleBitSets.emit(fieldData);
      }
    });
  }

  updateBitSetOfComposite(fieldData: Field, position: number) {
    if (fieldData.form.mandatory) {
      let tmp: HandleBitSet = { field: fieldData, position: position};
      // tmp.field = fieldData;
      // tmp.position = position;
      this.handleBitSetsOfComposite.emit(tmp);
    }
  }

  handleCompositeBitsetOfChildren(data: HandleBitSet) {
    this.handleBitSetsOfComposite.emit(data);
  }

  handleBitsetOfChildren(data: Field) {
    this.handleBitSets.emit(data);
  }

  unsavedChangesPrompt() {
    this.hasChanges.emit(true);
  }

  timeOut(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // printToConsole(name: string) {
  //   console.log(this.form.get(name).valid)
  // }

}
